export default "__VITE_ASSET__CMT8hx0K__"